import { pathToRegexp } from 'path-to-regexp';

export const LIS_ONLY_ROUTES: RegExp[] = [
    pathToRegexp('en-ca/about-adventure'),
    pathToRegexp('en-ca/cash/deposit'),
    pathToRegexp('en-ca/cash/history'),
    pathToRegexp('en-ca/cash/history/bets'),
    pathToRegexp('en-ca/cash/withdraw'),
    pathToRegexp('en-ca/hall-of-fame'),
    pathToRegexp('en-ca/jc-pay-and-play'),
    pathToRegexp('en-ca/jc-redirection-callback'),
    pathToRegexp('en-ca/player'),
    pathToRegexp('en-ca/player/documents-verification'),
    pathToRegexp('en-ca/player/play-okay-settings'),
    pathToRegexp('en-ca/player/settings'),
    pathToRegexp('en-gb/about-adventure'),
    pathToRegexp('en-gb/cash/deposit'),
    pathToRegexp('en-gb/cash/history'),
    pathToRegexp('en-gb/cash/history/bets'),
    pathToRegexp('en-gb/cash/withdraw'),
    pathToRegexp('en-gb/hall-of-fame'),
    pathToRegexp('en-gb/jc-pay-and-play'),
    pathToRegexp('en-gb/jc-redirection-callback'),
    pathToRegexp('en-gb/player'),
    pathToRegexp('en-gb/player/documents-verification'),
    pathToRegexp('en-gb/player/play-okay-settings'),
    pathToRegexp('en-gb/player/settings'),
    pathToRegexp('en-nz/about-adventure'),
    pathToRegexp('en-nz/cash/deposit'),
    pathToRegexp('en-nz/cash/history'),
    pathToRegexp('en-nz/cash/history/bets'),
    pathToRegexp('en-nz/cash/withdraw'),
    pathToRegexp('en-nz/hall-of-fame'),
    pathToRegexp('en-nz/jc-pay-and-play'),
    pathToRegexp('en-nz/jc-redirection-callback'),
    pathToRegexp('en-nz/player'),
    pathToRegexp('en-nz/player/documents-verification'),
    pathToRegexp('en-nz/player/play-okay-settings'),
    pathToRegexp('en-nz/player/settings'),
    pathToRegexp('en/about-adventure'),
    pathToRegexp('en/cash/deposit'),
    pathToRegexp('en/cash/history'),
    pathToRegexp('en/cash/history/bets'),
    pathToRegexp('en/cash/withdraw'),
    pathToRegexp('en/hall-of-fame'),
    pathToRegexp('en/jc-pay-and-play'),
    pathToRegexp('en/jc-redirection-callback'),
    pathToRegexp('en/logged-in'),
    pathToRegexp('en/logged-in-slugified/:slug'),
    pathToRegexp('en/player'),
    pathToRegexp('en/player/documents-verification'),
    pathToRegexp('en/player/play-okay-settings'),
    pathToRegexp('en/player/settings'),
    pathToRegexp('es/about-adventure'),
    pathToRegexp('es/cash/deposit'),
    pathToRegexp('es/cash/history'),
    pathToRegexp('es/cash/history/bets'),
    pathToRegexp('es/cash/history/monthly-summary/:month'),
    pathToRegexp('es/cash/withdraw'),
    pathToRegexp('es/hall-of-fame'),
    pathToRegexp('es/jc-pay-and-play'),
    pathToRegexp('es/jc-redirection-callback'),
    pathToRegexp('es/profile'),
    pathToRegexp('es/profile/documents-verification'),
    pathToRegexp('es/profile/play-okay-settings'),
    pathToRegexp('es/profile/settings'),
    pathToRegexp('fi/about-adventure'),
    pathToRegexp('fi/cash/deposit'),
    pathToRegexp('fi/cash/history'),
    pathToRegexp('fi/cash/history/bets'),
    pathToRegexp('fi/cash/withdraw'),
    pathToRegexp('fi/hall-of-fame'),
    pathToRegexp('fi/jc-pay-and-play'),
    pathToRegexp('fi/jc-redirection-callback'),
    pathToRegexp('fi/player'),
    pathToRegexp('fi/player/documents-verification'),
    pathToRegexp('fi/player/play-okay-settings'),
    pathToRegexp('fi/player/settings'),
    pathToRegexp('ie/about-adventure'),
    pathToRegexp('ie/cash/deposit'),
    pathToRegexp('ie/cash/history'),
    pathToRegexp('ie/cash/history/bets'),
    pathToRegexp('ie/cash/withdraw'),
    pathToRegexp('ie/hall-of-fame'),
    pathToRegexp('ie/jc-pay-and-play'),
    pathToRegexp('ie/jc-redirection-callback'),
    pathToRegexp('ie/player'),
    pathToRegexp('ie/player/documents-verification'),
    pathToRegexp('ie/player/play-okay-settings'),
    pathToRegexp('ie/player/settings'),
    pathToRegexp('no/about-adventure'),
    pathToRegexp('no/cash/deposit'),
    pathToRegexp('no/cash/history'),
    pathToRegexp('no/cash/history/bets'),
    pathToRegexp('no/cash/withdraw'),
    pathToRegexp('no/hall-of-fame'),
    pathToRegexp('no/jc-pay-and-play'),
    pathToRegexp('no/jc-redirection-callback'),
    pathToRegexp('no/player'),
    pathToRegexp('no/player/documents-verification'),
    pathToRegexp('no/player/play-okay-settings'),
    pathToRegexp('no/player/settings'),
    pathToRegexp('on/about-adventure'),
    pathToRegexp('on/cash/deposit'),
    pathToRegexp('on/cash/history'),
    pathToRegexp('on/cash/history/bets'),
    pathToRegexp('on/cash/withdraw'),
    pathToRegexp('on/hall-of-fame'),
    pathToRegexp('on/jc-pay-and-play'),
    pathToRegexp('on/jc-redirection-callback'),
    pathToRegexp('on/player'),
    pathToRegexp('on/player/documents-verification'),
    pathToRegexp('on/player/play-okay-settings'),
    pathToRegexp('on/player/settings'),
    pathToRegexp('sv/cash/deposit'),
    pathToRegexp('sv/cash/history'),
    pathToRegexp('sv/cash/history/bets'),
    pathToRegexp('sv/cash/withdraw'),
    pathToRegexp('sv/hall-of-fame'),
    pathToRegexp('sv/jc-pay-and-play'),
    pathToRegexp('sv/jc-redirection-callback'),
    pathToRegexp('sv/player'),
    pathToRegexp('sv/player/documents-verification'),
    pathToRegexp('sv/player/play-okay-settings'),
    pathToRegexp('sv/player/settings')
] as const;
